/* @ngInject */
const contactIcons = () => {
  const self = {}

  self.lastname = 'account_circle'
  self.firstname = 'account_circle'
  self.function = 'assignment'
  self.phone = 'call'
  self.email = 'email'
  self.comment = 'mode_edit'

  return self
}

export default contactIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/resources/icons.resource.js